export const API_BASE_URL =
  "https://api.kvlmatrimony.com/api/v1";

// export const API_BASE_URL =
//   "http://localhost:5300/api/v1";

export const API_PATHS = {

  // file upload
  userFileUpload: "/upload",
  uploadAadhaar: "/uploadaadhaar",
  smartocr: "/smartocr",

  // userLogin <-------
  userlogin: "/login",
  userLoginOtpVerify: "/verifyLoginOtp",
  createVerification: "/createVerification",
  getAadhaarDocument: "/getAadhaarDocument",
  getSubCaste: "/get-subcaste",
  deletePhoto: "/delete-photo",

  sendotp: "/change-mobile/send-otp",
  verfyotp: "/change-mobile/verify-otp",

  sendemailotp: "/change-email/send-otp",
  verifyemailotp: "/change-email/verify-otp",


  // userRegister <------
  userRegister: "/register",
  userOtpverify: "/verifyOtp",
  getmyPlan: "/getmyplan",
  activateFreeSubscription: "/activateFreeSubscription",

  // profile get 
  getProfile: "/getProfile",
  updateProfile: "/updateProfile",
  updateProfessionalDetails: "/updateProfessionalDetails",
  updateFamilyDetails: "/updateFamilyDetails",
  viewContact: "/viewContact",

  // preference 
  getPreference: "/getPreference",
  updatePreference: "/updatePreference",
  searchProfile: "/searchProfile",
  getProfileById: "/getProfileById",
  getReceivedInterests: "/getReceivedInterests",
  getSentInterests: "/getSentInterests",
  respondToInterest: "/respondToInterest",
  getShortlistData: "/getShortlistData",

  getRecentActivity: "/getRecentActivity",
  getPreferredMatches: "/getPreferredMatches",

  // shortlisted and Send intrested
  sendInterest: "/sendInterest",
  shortlistUser: "/shortlistUser",

  getConversation: "/getConversations",
  getMessage: "/getMessage",
  sendMessage: "/sendMessage",
  getConversationByUser: "/getConversationByUser",


  // GetPlans
  getPlans: "/get-plan",
  addVisitor: "/visit",
  getVisitor: "/visit/count",

  // admin user ==== >
  addUser: "admin/add-user",
  gedUser: "admin/get-user",
  edidUser: "admin/edit-user",
  deletdUser: "admin/delete-user",


  // payment 
  buyPlan: "/buy-plan",
  storePayment: "/storePayment",

  //privacy
  getPrivacy: "/getPrivacy",
  updatePrivacy: "/updatePrivacy",


  // Chatbot
  chatbotMessage: "/chatbot/message",

  // Chatbot FAQ
  addChatFaq: "/chatbot/faq",
  getChatFaq: "/chatbot/faq",
  getChatFaqById: "/chatbot/faq",
  updateChatFaq: "/chatbot/faq",
  deleteChatFaq: "/chatbot/faq",
  toggleChatFaqStatus: "/chatbot/faq",
  bulkDeleteChatFaq: "/chatbot/faq/bulk-delete",

  // Chatbot Intent
  addChatIntent: "/chatbot/intent",
  getChatIntent: "/chatbot/intent",
  getChatIntentById: "/chatbot/intent",
  updateChatIntent: "/chatbot/intent",
  deleteChatIntent: "/chatbot/intent",
  toggleChatIntentStatus: "/chatbot/intent",
  bulkDeleteChatIntent: "/chatbot/intent/bulk-delete",

  // Chatbot Entity
  addChatEntity: "/chatbot/entity",
  getChatEntity: "/chatbot/entity",
  getChatEntityById: "/chatbot/entity",
  updateChatEntity: "/chatbot/entity",
  deleteChatEntity: "/chatbot/entity",
  toggleChatEntityStatus: "/chatbot/entity",
  bulkDeleteChatEntity: "/chatbot/entity/bulk-delete",

  // Chatbot Analytics
  chatbotDashboard: "/chatbot/analytics/dashboard",
  chatbotTopQuestions: "/chatbot/analytics/top-questions",
  chatbotTopIntents: "/chatbot/analytics/top-intents",
  chatbotUnanswered: "/chatbot/analytics/unanswered",
  chatbotRecent: "/chatbot/analytics/recent",
  chatbotByDate: "/chatbot/analytics/by-date",





};
